import { motion, MotionStyle } from 'framer-motion';
import { useTranslation } from 'react-i18next';

interface OpenChatButtonProps {
  isLoading?: boolean;
  isLoaded?: boolean;
  onClick?: () => void;
}

const OpenChatButton = ({ onClick }: OpenChatButtonProps) => {
  const { t } = useTranslation();

  return (
    <motion.div whileTap={{ scale: 0.9 }} style={buttonStyle} onClick={onClick}>
      <span style={{ fontSize: '17px' }}>{t('matched_popup.open_chat')}</span>
    </motion.div>
  );
};

const buttonStyle: MotionStyle = {
  width: 'calc(100% - 65px)',
  height: '50px',
  color: '#000',
  border: 'none',
  borderRadius: '45px',
  background: '#FDCA3F',
  fontSize: '20px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  outline: 'none',
  textAlign: 'center',
  appearance: 'none',
  fontWeight: 500,
  marginBottom: '10px'
};

export default OpenChatButton;
